<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo
        :titulo="locale[local].screen.pontoTeletex.string006"
      />
      <v-divider />

      <v-row justify="space-around">
        <v-col cols="12" md="8" lg="10" xl="9">
          <v-switch
            v-model="mostraTodos"
            :label="`Mostrar Todos`"
            @change="changedTodos"
          ></v-switch>
        </v-col>
      </v-row>


      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ props }"> 
            <v-btn
              color="primary"
              class="white--text"
              small
              @click="incluir()"
            >
              <span> Incluir Solicitação </span>
              <v-icon right medium> mdi-plus </v-icon>
          </v-btn>
            <v-btn
              color="primary"
              class="white--text"
              small
             @click="dialogMarcacao = true"
            style="margin-right: 25px;"
            >
              <span> Marcação Ponto </span>
              <v-icon right medium> mdi-bookmark-multiple-outline </v-icon> 
            </v-btn>             
          </template>
        </v-dialog>
      </v-toolbar>

      <div class="ma-5">
        <v-card outlined elevation="0">
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="20"
            >
            <template v-slot:[`item.dtMovto`]="{ item }">
              {{
                item.dtMovto
                  ? moment(item.dtMovto).format("DD/MM/YYYY")
                  : "Sem data informada"
              }}
            </template>                      
            </v-data-table>

          </v-card-text>
        </v-card>
      </div>
    </v-content>

    <v-card>
      <v-card-text>
        <v-overlay v-model="carregando">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card-text>
    </v-card>

    <v-dialog width="640px" v-model="dialog" scrollable persistent>
      <v-form ref="form">
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar color="primary" class="white--text">
              Solicitação de Ajuste
            </v-toolbar>
          </v-card-title>

          <v-card-text class="pt-8">
            <v-row>
              <v-col lg="6">
                <cgi-date-picker
                  :regras="[(v) => !!v || 'Preencha o campo']"
                  compacto
                  nome="Data"
                  v-model="ttPontoTeletex.dtMovto"
                >
                </cgi-date-picker>
              </v-col>
            </v-row>

            <v-row>
              <v-col lg="6">
                <v-checkbox
                  :disabled="ttPontoTeletex.dtMovto === null"
                  v-model="ttPontoTeletex.tipo1"
                  :label="locale[local].screen.pontoTeletex.string001"
                  color="primary"
                  dense
                ></v-checkbox>
              </v-col>
              <v-col v-show="ttPontoTeletex.tipo1" cols="3">
                <cgi-time-picker
                  v-model="ttPontoTeletex.hrMovtoIni"
                  nome="Hora Inicial"
                  compacto
                ></cgi-time-picker>
              </v-col>
              <v-col v-show="ttPontoTeletex.tipo1" cols="3">
                <cgi-time-picker
                  v-model="ttPontoTeletex.hrMovtoFim"
                  nome="Hora Final"
                  compacto
                ></cgi-time-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox
                  :disabled="ttPontoTeletex.dtMovto === null"
                  v-model="ttPontoTeletex.tipo2"
                  :label="locale[local].screen.pontoTeletex.string002"
                  color="primary"
                  @click="buscaMarcacaoPontoTeletex()"
                  dense
                ></v-checkbox>
              </v-col>
              <v-col v-show="ttPontoTeletex.tipo2" cols="6">
                <v-select
                  filled
                  :items="ttPontoHora"
                  item-text="segMovto"
                  item-value="segMovto"
                  dense
                  :label="locale[local].screen.pontoTeletex.string002"
                  v-model="ttPontoTeletex.hrMovtoIni"
                ></v-select>
              </v-col>
            </v-row>            

            <v-row>
              <v-col>
                <v-checkbox
                  :disabled="ttPontoTeletex.dtMovto === null || ttPontoTeletex.tipo1 != false"
                  v-model="ttPontoTeletex.tipo4"
                  :label="locale[local].screen.pontoTeletex.string004"
                  color="primary"
                  @click="buscaEventoFolgaTeletex()"
                  dense
                ></v-checkbox>
              </v-col>
              <v-col v-show="ttPontoTeletex.tipo4" cols="5">
                <v-select
                  filled
                  :items="ttFolga"
                  item-text="nomeEvento"
                  item-value="codEvento"
                  dense
                  :label="locale[local].screen.pontoTeletex.string004"
                  v-model="ttPontoTeletex.codEvento"
                ></v-select>
              </v-col>
              <v-col v-show="ttPontoTeletex.tipo4" cols="2">
                <cgi-time-picker
                  v-model="ttPontoTeletex.hrMovtoIni"
                  nome="Início"
                  compacto
                ></cgi-time-picker>
              </v-col>
              <v-col v-show="ttPontoTeletex.tipo4" cols="2">
                <cgi-time-picker
                  v-model="ttPontoTeletex.hrMovtoFim"
                  nome="Fim"
                  compacto
                ></cgi-time-picker>
              </v-col>
            </v-row>            

            <v-row>
              <v-col>
                <v-checkbox
                  :disabled="ttPontoTeletex.dtMovto === null"
                  v-model="ttPontoTeletex.tipo3"
                  :label="locale[local].screen.pontoTeletex.string003"
                  color="primary"
                  dense
                ></v-checkbox>
              </v-col>

              <v-col>
                <v-checkbox
                  :disabled="ttPontoTeletex.dtMovto === null"
                  v-model="ttPontoTeletex.tipo5"
                  :label="locale[local].screen.pontoTeletex.string005"
                  color="primary"
                  dense
                ></v-checkbox>
              </v-col>

              <v-col>
                <v-checkbox
                  :disabled="ttPontoTeletex.dtMovto === null"
                  v-model="ttPontoTeletex.tipo6"
                  :label="locale[local].screen.pontoTeletex.string007"
                  color="primary"
                  dense
                ></v-checkbox>
              </v-col>
            </v-row>            

            <v-row>
              <v-textarea
                :rules="[(v) => !!v || 'Preencha o campo']"
                v-model="ttPontoTeletex.observacao"
                label="Observação"
                required
                dense
              ></v-textarea>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="red" small @click="dialog = false">
              <v-icon right medium> mdi-close</v-icon>
              <span> Cancelar </span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="white--text" small @click="salvar()">
              <v-icon right medium> mdi-content-save </v-icon>
              <span> Salvar </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  <v-dialog v-model="dialogMarcacao" max-width="1300">
    <v-card>
      <v-btn
        icon
        @click="dialogMarcacao = false"
        style="position: absolute; top: 10px; right: 10px; z-index: 1;"
        >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text>
        <MarcacaoPonto />
      </v-card-text>
    </v-card>
  </v-dialog>
</v-app>
  
</template>

<script>
import Service from "../components/api/Service";
import moment from "moment";
import { snackbar, alert} from "cids-cgi/lib/util";
import MarcacaoPonto from './MarcacoesPonto.vue';


export default {
  components: { MarcacaoPonto },
  data: () => ({
    snackbar: false,
    loading: false,
    dialog: false,
    dialogMarcacao: false,

    headers: [
      {
        text: "Data",
        value: "dtMovto",
        divider: true,
      },
      {
        text: "Tipo",
        value: "tipoNome",
        divider: true,
      },
      {
        text: "Situação",
        value: "situacaoNome",
        divider: true,
      },
      {
        text: "Sequência",
        value: "sequencia",
        divider: true,
      },
      {
        text: "Hora Inicial",
        value: "hrIniMovtoChar",
        divider: true,
      },
      {
        text: "Hora Fim",
        value: "hrFimMovtoChar",
        divider: true,
      },
      {
        text: "Evento",
        value: "codEvento",
        divider: true,
      },
      {
        text: "Descrição",
        value: "eventoNome",
        divider: true,
      },
      {
        text: "Observação",
        value: "observacao",
        divider: true,
      },
      {
        text: "Retorno do RH",
        value: "justificativa",
        divider: true,
      },
    ],
    items: [],
    carregando: false,
    ttPontoTeletex: {
      dtMovto: null,
      hrMovtoIni: null,
      hrMovtoFim: null,
      tipo1: false,
      tipo2: false,
      tipo3: false,
      tipo4: false,
      tipo5: false,
      tipo6: false,
      codEvento: 0,
      observacao: "",
    },
    ttPontoHora: [],
    ttFolga: [],
    mostraTodos: false,
  }),
  async mounted() {},
  created() {
    moment.locale("pt-br");
    this.buscarPontoTeletex(false);
  },
  methods: {
    async redirecionar() {
      try {
        this.loading = true;
        
      } finally {
        this.loading = false;
      }
    },

    async buscarPontoTeletex(todos) {
      this.loading = true;
      this.carregando = true;

      try {
        const service = new Service();
        this.items = await service.buscarPontoTeletex(todos);

        this.loading = false;
      } catch (e) {
        this.loading = false;
      } finally {
        this.carregando = false;
      }
    },
    async buscaMarcacaoPontoTeletex() {
      this.loading = true;
      this.carregando = true;

      try {

        this.ttPontoHora = []
        if  (this.ttPontoTeletex.tipo2 === true) {
          const service = new Service();
          this.ttPontoHora = await service.buscaMarcacaoPontoTeletex(this.ttPontoTeletex);
        }

        if (this.ttPontoHora[0].observacao === "Sem registro"){
          alert.show({ message: "Não existe registro a ser excluído" });
          this.ttPontoTeletex.tipo2 = false
        }

        this.loading = false;
      } catch (e) {
        this.loading = false;
      } finally {
        this.carregando = false;
      }
    },
    async buscaEventoFolgaTeletex(){
      this.loading = true;
      this.carregando = true;

      try {
        this.ttFolga = []
        if  (this.ttPontoTeletex.tipo4 === true) {
          const service = new Service();
          this.ttFolga = await service.buscaEventoFolgaTeletex();
          this.ttPontoTeletex.codEvento = this.ttFolga[0].codEvento
        }

        this.loading = false;
      } catch (e) {
        this.loading = false;
      } finally {
        this.carregando = false;
      }
    },
    async incluir() {  
      this.ttPontoTeletex = {
      dtMovto: null,
      hrMovtoIni: '0',
      hrMovtoFim: '0',
      tipo1: false,
      tipo2: false,
      tipo3: false,
      tipo4: false,
      tipo5: false,
      tipo6: false,
      codEvento: 0,
      observacao: "",
      }

      this.dialog = true
    },    
    async salvar() {
      this.loading = true;
      this.carregando = true;

      if  (this.ttPontoTeletex.tipo4 === true && 
           this.ttPontoTeletex.codEvento === 0 ) {
        alert.show({ message: "Informe o Evento a ser gravado" });
        return
      }

      if (this.$refs.form.validate()) {
        const service = new Service();
        const retorno = await service.salvaAjusteTeletex(this.ttPontoTeletex);

        if (retorno[0].estatus === "Sucesso") {
          snackbar.show({
            message: retorno[0].msgErro.split(" - ")[1],
            color: "green",
            timeout: 3000,
          });

          this.buscarPontoTeletex(false);
        } else {
          snackbar.show({
            message: retorno[0].msgErro.split(" - ")[1],
            color: "red",
            timeout: 3000,
          });
        }
      } else {
        this.loading = false;
        this.carregando = false;
        return;
      }

      this.dialog = false;
      this.loading = false;
      this.carregando = false;

      this.ttPonto.dtMovto = null;
      this.ttPonto.segMovto = null;
      this.ttPonto.observacao = "";
    },

   
    changedTodos(valor){
      if (valor === true){
        this.buscarPontoTeletex(true)
      } else
      {
        this.buscarPontoTeletex(false)
      }
    },

  },

};
</script>
